import React from 'react';
import { Col, Form, InputNumber, Row, Typography } from 'components';
import { preventNonNumericValue, toNumberOrMinusOne } from 'utils/helpers';

const { Text } = Typography;

interface IFeesAndCharges {
  handleFormItemBlur: (fieldKey: string, value: string | number, groupObj?: string) => void;
}

export const FeesAndCharges = React.memo((props: IFeesAndCharges) => {
  const { handleFormItemBlur } = props;

  return (
    <Row style={{ padding: '20px' }} gutter={[0, 20]}>
      <Col span={24}>
        <Text style={{ color: '#05796B' }} className={'font-weight-800 font-size-16'}>
          Fees and Charges
        </Text>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 20]}>
          <Col span={12}>
            <Form.Item
              name={['fee', 'duty']}
              label={'Duty Fee'}
              rules={[
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === '') {
                      return Promise.resolve();
                    }
                    const num = parseFloat(value);
                    if (isNaN(num)) {
                      return Promise.reject(new Error('Duty Fee must be a valid number.'));
                    }
                    if (num < 0) {
                      return Promise.reject(new Error('Duty Fee must be a positive number.'));
                    }
                    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject(new Error('Duty Fee can have up to 2 decimal points.'));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber<number>
                controls={false}
                size={'large'}
                onBlur={(e) => handleFormItemBlur('duty', toNumberOrMinusOne(e.target.value), 'fee')}
                onBeforeInput={(event: any) => preventNonNumericValue(event)}
                style={{ width: '100%' }}
                suffix={<Text type={'secondary'}>%</Text>}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={['fee', 'bankTransfer']}
              label={'Bank Transfer Fee'}
              rules={[
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === '') {
                      return Promise.resolve();
                    }
                    const num = parseFloat(value);
                    if (isNaN(num)) {
                      return Promise.reject(new Error('Bank Transfer Fee must be a valid number.'));
                    }
                    if (num < 0) {
                      return Promise.reject(new Error('Bank Transfer Fee must be a positive number.'));
                    }
                    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject(new Error('Bank Transfer Fee can have up to 2 decimal points.'));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber<number>
                controls={false}
                size={'large'}
                onBlur={(e) => handleFormItemBlur('bankTransfer', toNumberOrMinusOne(e.target.value), 'fee')}
                onBeforeInput={(event: any) => preventNonNumericValue(event)}
                style={{ width: '100%' }}
                suffix={<Text type={'secondary'}>€</Text>}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={['fee', 'customsClearance']}
              label={'Customs Clearance Fee'}
              rules={[
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === '') {
                      return Promise.resolve();
                    }
                    const num = parseFloat(value);
                    if (isNaN(num)) {
                      return Promise.reject(new Error('Customs Clearance Fee must be a valid number.'));
                    }
                    if (num < 0) {
                      return Promise.reject(new Error('Customs Clearance Fee must be a positive number.'));
                    }
                    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject(new Error('Customs Clearance Fee can have up to 2 decimal points.'));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber<number>
                controls={false}
                size={'large'}
                onBlur={(e) => handleFormItemBlur('customsClearance', toNumberOrMinusOne(e.target.value), 'fee')}
                onBeforeInput={(event: any) => preventNonNumericValue(event)}
                style={{ width: '100%' }}
                suffix={<Text type={'secondary'}>€</Text>}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={['fee', 'minimumOrder']}
              label={'Minimum Order Fee'}
              rules={[
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === '') {
                      return Promise.resolve();
                    }
                    const num = parseFloat(value);
                    if (isNaN(num)) {
                      return Promise.reject(new Error('Minimum Order Fee must be a valid number.'));
                    }
                    if (num < 0) {
                      return Promise.reject(new Error('Minimum Order Fee must be a positive number.'));
                    }
                    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject(new Error('Minimum Order Fee can have up to 2 decimal points.'));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber<number>
                controls={false}
                size={'large'}
                onBlur={(e) => handleFormItemBlur('minimumOrder', toNumberOrMinusOne(e.target.value), 'fee')}
                onBeforeInput={(event: any) => preventNonNumericValue(event)}
                style={{ width: '100%' }}
                suffix={<Text type={'secondary'}>€</Text>}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
});
